import "regenerator-runtime/runtime";
import "lib/polyfills";
import "styles/tailwind.css";
import "lib/monkeyPatching";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { getClientLocation } from "lib/apis/walletLocationEvents";
import { bootstrapI18n } from "lib/i18n";
const Router = BrowserRouter as any;

import App from "./App/App";
import { AppProviders } from "./App/AppProviders";
import reportWebVitals from "./reportWebVitals";

// Allow disabling StrictMode in dev to silence legacy lifecycle warnings
// Set VITE_USE_STRICT=false in .env to render without StrictMode
const Strict = import.meta.env.VITE_USE_STRICT === "false" ? React.Fragment : React.StrictMode;

async function startApp() {
  let countryCode: string | null | undefined;

  try {
    countryCode = (await getClientLocation()).countryCode;
  } catch (error) {
    // Browser language remains the automatic fallback when the optional location hint is unavailable.
    // eslint-disable-next-line no-console
    console.warn("Unable to resolve the initial locale from the client location", error);
  }

  try {
    await bootstrapI18n(undefined, countryCode);
  } catch (error) {
    // Rendering in English is safer than leaving the application blank if a catalog chunk cannot load.
    // eslint-disable-next-line no-console
    console.warn("Unable to preload the selected language catalog", error);
  }

  createRoot(document.getElementById("root")!).render(
    <Strict>
      <Router>
        <AppProviders>
          <App />
        </AppProviders>
      </Router>
    </Strict>
  );
}

void startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export { formatTokenAmount, formatTokenAmountWithUsd, formatUsd } from "./lib/numbers";
